import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
// import { setAccessToken } from "../admin/adminSlice";

export const apiSlice = createApi({
    reducerPath: 'api',
    baseQuery: fetchBaseQuery({
        baseUrl: 'https://mahbub-backend.vercel.app',
    }),
    tagTypes: ["projects"],
    endpoints: (builder) => ({
        
        getProjects: builder.query({
            query: (page) => ({
                url: `/projects/${page}`,
                // headers: { authorization: `Bearer ${JSON.parse(sessionStorage.getItem("accessToken"))}` }
            }),
            providesTags: ["projects"]

        }),
        getProject: builder.query({
            query: (ProjectId) => `/projects/sing/${ProjectId}`,
            invalidatesTags: ["projects"]
        })

    }),

});

export const {
    useGetProjectQuery,
    useGetProjectsQuery
} = apiSlice;